import React from 'react';

import './styles.css';

const ParentObject = ({children}) => {
  return <div className="ParentObject">{children}</div>;
};

export default ParentObject;
